import { render } from 'solid-js/web';
import '@mako/tokens';
import './styles/base.css';
import './styles/auth.css';
import './styles/shell.css';
import './styles/mail.css';
import './styles/pilot.css';

// La maquette interactive (VITE_DEMO=1) installe l'API simulée avant tout : la session et le store lisent /api
// dès leur chargement, d'où l'import différé de l'app.
async function start() {
  if (import.meta.env.VITE_DEMO === '1') (await import('./demo/install.ts')).installDemo();
  const { App } = await import('./App.tsx');
  render(() => <App />, document.getElementById('root')!);
}
void start();
